import { UseApi } from '../utils/axios-pettitions';

export async function getMonitoreoInventario(params?: any) {
    const { runApi } = UseApi();
    return await runApi('monitoreoInventario', 'GET', params);
}
